import { render, staticRenderFns } from "./DlgGroupDelete.vue?vue&type=template&id=47015db0&scoped=true"
import script from "./DlgGroupDelete.vue?vue&type=script&lang=js"
export * from "./DlgGroupDelete.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47015db0",
  null
  
)

export default component.exports